import React, { useState } from 'react';
import Modal from './Modal';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import axiosInstance from "../utility/axiosInstance";
import { useToast } from "./ToastContext";
import { getSelectStyles } from '../utility/selectStyles';

interface UpdateClusterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onUpdated: () => void;
    cluster: any;
}

const UpdateClusterModal: React.FC<UpdateClusterModalProps> = ({ isOpen, onClose, onUpdated, cluster }) => {
    const { showToast } = useToast();
    const images = useSelector((state: RootState) => state.images.data);
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const imageOptions = images.map(img => ({ value: img.id, label: img.name }));

    const handleSubmit = async () => {
        if (!selectedImage) {
            showToast('Please select a snapshot/image', 'error');
            return;
        }

        setIsSubmitting(true);
        try {
            await axiosInstance.patch(`/v1/clusters/${cluster.stack_name}/${cluster.id}`, {
                image: selectedImage.value
            });

            showToast('Cluster update started', 'success');
            onUpdated();
            onClose();
        } catch (error: any) {
            console.error("Error updating cluster:", error);
            showToast(error.response?.data?.error || 'Failed to update cluster', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Update Cluster: ${cluster?.stack_name}`} size="md">
            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="create-form">
                <p style={{ marginBottom: '20px', color: 'var(--text-muted)' }}>
                    Perform a rolling update on the cluster by selecting a new snapshot or image.
                </p>

                <div className="form-group">
                    <label>Select New Snapshot/Image</label>
                    <Select
                        options={imageOptions}
                        value={selectedImage}
                        onChange={setSelectedImage}
                        placeholder="Select image..."
                        isSearchable={true}
                        styles={getSelectStyles()}
                    />
                </div>

                <div className="modal-actions" style={{ marginTop: '20px' }}>
                    <button
                        type="button"
                        className="cancel-button"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="submit-button"
                        disabled={isSubmitting || !selectedImage}
                    >
                        {isSubmitting ? 'Updating...' : 'Update Cluster'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default UpdateClusterModal;
